// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Router from 'vue-router';
import store from './vuex/store'
import ElementUI from 'element-ui'
import VCharts from 'v-charts'
import ViewUI from 'view-design';
// import Antd from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.css'
import 'view-design/dist/styles/iview.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/element-ui-color.css'
Vue.use(Router)
Vue.use(ElementUI)
Vue.use(VCharts)
Vue.use(ViewUI)


import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'MfFfux8xwwEkMBEv4Q3Tm1y8hDiOxaM4'
})

import axios from 'axios'
Vue.prototype.$axios = axios    // c全局注册，使用方法为:this.$axios
axios.defaults.baseURL = "https://jinyuadmin.yueyat.net/api/" 

import vueSeamlessScroll from 'vue-seamless-scroll' // 无缝滚动
Vue.use(vueSeamlessScroll)

import echarts from 'echarts'
Vue.prototype.$echarts = echarts


const VueRouterPush = Router.prototype.push       // 解决Tab点击报错
Router.prototype.push = function push (to) { // 解决Tab点击报错
  return VueRouterPush.call(this, to).catch(err => err) // 解决Tab点击报错
}


router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js